import { Typography, makeStyles } from '@material-ui/core';
import { Trans } from '@lingui/macro';
import { InfoOutlined } from '@material-ui/icons';

import { panelPropDefaults, panelPropTypes } from '../../page-framework/panel/PanelPropTypes';
import Panel from '../../page-framework/panel/PanelDecorator';

const useStyles = makeStyles((theme) => ({
    container: {
        height: '40vh',
        display: 'flex',
        gap: 8,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',

        '& > .noAccessTitle': {
            display: 'flex',
            alignItems: 'center',
            gap: 8,

            '& svg': {
                fontSize: 36,
                color: theme.palette.info.main,
            },
        },

        '& > .noAccessDescription': {
            width: 640,
        },
    },
}));

function NoAccessPanel() {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <span className="noAccessTitle">
                <InfoOutlined />
                <Typography variant="h4">
                    <Trans>No Access</Trans>
                </Typography>
            </span>
            <span className="noAccessDescription">
                <Typography variant="body1">
                    <Trans>
                        You have not been given any permissions within the nGeniusPULSE application. Contact a system
                        administrator to grant you the appropriate permissions.
                    </Trans>
                </Typography>
            </span>
        </div>
    );
}

NoAccessPanel.propTypes = panelPropTypes;

NoAccessPanel.defaultProps = {
    ...panelPropDefaults,
    flexHeight: true,
};

export default Panel({})(NoAccessPanel);
